export function isBot(): boolean {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.includes('pingdom')) {
    return true
  }
  return false
}
